import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  option: {
    "&[aria-selected='true']": {
      backgroundColor: theme.tokens.colors.bg.light.primary,
      color: theme.tokens.colors.original.brand.primary,
    },
  },

  paper: {
    scrollbarWidth: 'thin',
    marginBottom: theme.tokens.spacing['4'],
  },

  popper: {
    paddingBottom: theme.tokens.spacing['8'],
    width: '75px !important',
  },

  input: {
    padding: `${theme.tokens.spacing['2']}px ${theme.tokens.spacing['4']}px !important`,
    height: 24,

    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },

    '& .MuiAutocomplete-input': {
      padding: '0 !important',
    },
  },

  root: {
    width: 65,
    display: 'flex',
    alignItems: 'center',

    '& .MuiAutocomplete-popupIndicator': {
      fontSize: theme.tokens.typography.variant.caption.fontSize,
    },
    '& .MuiAutocomplete-endAdornment': {
      left: 45,
      '& svg': {
        color: theme.tokens.colors.original.brand.secondary,
      },
    },
  },

  inputRoot: {
    '& .MuiInputBase-input': {
      paddingBottom: '0 !important',
      color: theme.tokens.colors.original.brand.secondary,
    },
  },

  rootBox: {
    backgroundColor: theme.tokens.colors.original.brand.primary,
    '& .MuiButtonGroup-groupedHorizontal:not(:nth-of-type(3n), :nth-of-type(5n))::after':
      {
        backgroundColor: `${theme.tokens.colors.original.brand.primary} !important`,
      },
  },

  buttonGroup: {
    position: 'fixed',
    bottom: 40,
    left: '50%',
    zIndex: 10000,
    transform: 'translateX(-50%)',
  },

  bottomOffset: {
    bottom: 112,
  },

  hiddenGroup: {
    '& .MuiButtonGroup-grouped:nth-of-type(1), .MuiButtonGroup-grouped:nth-of-type(2), .MuiButtonGroup-grouped:nth-of-type(3)':
      {
        display: 'none',
      },
    '& .MuiButtonGroup-grouped:nth-of-type(4)': {
      borderTopLeftRadius: `${theme.tokens.radius.m}px !important`,
      borderBottomLeftRadius: `${theme.tokens.radius.m}px !important`,
    },
  },
}));
